// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container general */
.Navigation_container__-cto7 {
  max-width: 1140px;
  width: 100%;
  padding-top: 60px;
}

/* Bara de navigare */
.Navigation_navigation__xIjqU {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #f8f8f8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 9px 0px;
}

.Navigation_navigation__xIjqU ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
}

.Navigation_navigation__xIjqU li {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(20% - 10px); /* Elemente egale pe un rând, ajustabile */
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;
}

.Navigation_navLink__7PcdX {
  display: flex;
  flex-direction: column; /* Imaginea deasupra textului */
  align-items: center;
  justify-content: flex-start; /* Textul apare imediat sub imagine */
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 8px; /* Colțuri rotunjite */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;
  cursor: pointer;
}

.Navigation_navLink__7PcdX:hover {
  transform: translateY(-5px); /* Ridicare ușoară la hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Umbra mai puternică la hover */
  color: #e63946;
}

.Navigation_navImage__JfPTR {
  max-width: 130px;
  height: 130px;
  object-fit: cover; /* Păstrează proporțiile imaginii */
  margin-bottom: 8px; /* Spațiu mai mic între imagine și text */
  margin-top: 10px;
}

.Navigation_navLink__7PcdX span {
  margin-top: 0; /* Elimină spațiu suplimentar între imagine și text */
  font-size: 14px;
  font-weight: 500;
  color: inherit;
}

.Navigation_name__sA6NV {
  margin-bottom: 15px;
}

/* Responsive */
@media (max-width: 768px) {
  .Navigation_navigation__xIjqU ul {
    padding: 5px;
    justify-content: space-around;
  }

    .Navigation_navLink__7PcdX:hover {
    transform: none; /* Elimină ridicarea */
    box-shadow: none; /* Elimină umbra */
    color: inherit; /* Păstrează culoarea inițială */
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,0CAA0C;IACtE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,sEAAsE;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+BAA+B;EACvD,mBAAmB;EACnB,2BAA2B,EAAE,qCAAqC;EAClE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB,EAAE,sBAAsB;EAC1C,wCAAwC;EACxC,qBAAqB;EACrB,WAAW;EACX,sEAAsE;EACtE,eAAe;AACjB;;AAEA;EACE,2BAA2B,EAAE,6BAA6B;EAC1D,wCAAwC,EAAE,iCAAiC;EAC3E,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB,EAAE,mCAAmC;EACtD,kBAAkB,EAAE,yCAAyC;EAC7D,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,qDAAqD;EACpE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,6BAA6B;EAC/B;;IAEE;IACA,eAAe,EAAE,sBAAsB;IACvC,gBAAgB,EAAE,kBAAkB;IACpC,cAAc,EAAE,gCAAgC;EAClD;;AAEF","sourcesContent":["/* Container general */\n.container {\n  max-width: 1140px;\n  width: 100%;\n  padding-top: 60px;\n}\n\n/* Bara de navigare */\n.navigation {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  background-color: #f8f8f8;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 9px 0px;\n}\n\n.navigation ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.navigation li {\n    flex: 1 1 calc(20% - 10px); /* Elemente egale pe un rând, ajustabile */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;\n}\n\n.navLink {\n  display: flex;\n  flex-direction: column; /* Imaginea deasupra textului */\n  align-items: center;\n  justify-content: flex-start; /* Textul apare imediat sub imagine */\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  border-radius: 8px; /* Colțuri rotunjite */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  text-decoration: none;\n  color: #333;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n}\n\n.navLink:hover {\n  transform: translateY(-5px); /* Ridicare ușoară la hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Umbra mai puternică la hover */\n  color: #e63946;\n}\n\n.navImage {\n  max-width: 130px;\n  height: 130px;\n  object-fit: cover; /* Păstrează proporțiile imaginii */\n  margin-bottom: 8px; /* Spațiu mai mic între imagine și text */\n  margin-top: 10px;\n}\n\n.navLink span {\n  margin-top: 0; /* Elimină spațiu suplimentar între imagine și text */\n  font-size: 14px;\n  font-weight: 500;\n  color: inherit;\n}\n\n.name {\n  margin-bottom: 15px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .navigation ul {\n    padding: 5px;\n    justify-content: space-around;\n  }\n\n    .navLink:hover {\n    transform: none; /* Elimină ridicarea */\n    box-shadow: none; /* Elimină umbra */\n    color: inherit; /* Păstrează culoarea inițială */\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Navigation_container__-cto7`,
	"navigation": `Navigation_navigation__xIjqU`,
	"navLink": `Navigation_navLink__7PcdX`,
	"navImage": `Navigation_navImage__JfPTR`,
	"name": `Navigation_name__sA6NV`
};
export default ___CSS_LOADER_EXPORT___;
